/* eslint-disable no-shadow, no-param-reassign */

// Reuseable store for globally controlled layout elements (right panel, above content, footer).
// Must be registered manually at the element.

import { make } from 'vuex-pathify';

const state = () => ({
  isOpen: false,
  isFullyOpen: false, //if the transition/animation has been completed
  isCompact: false,
  title: '',
});

const mutations = {
  ...make.mutations(state),
};

export default {
  namespaced: true,
  state,
  mutations,
};
